export enum DeformationToolType {
  ffd,
  softModification,
  paintModification,
}